import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const Education  = () => {

  const  servicesFaqData = [
    { 
        question: "What is education printing, and what materials does it include? ", 
        answer: "Education printing encompasses the creation of materials such as textbooks, workbooks, classroom posters, and learning tools used in academic settings. It includes high-quality printing services for physical books, promotional flyers, event materials, and innovative tools like 3D-printed models. These materials support teaching, enhance learning experiences, and promote educational events. Education printing serves schools, colleges, universities, and training centres, providing essential resources for effective instruction and engagement."
    },
    { 
        question: "What are the benefits of 3D printing in education?  ", 
        answer: "3D printing education enables the creation of tangible models and prototypes that enhance experiential learning. It allows students to visualise complex concepts in subjects like science, technology, engineering, and mathematics (STEM). 3D printing fosters creativity, problem-solving, and hands-on learning by making abstract ideas concrete. Additionally, it provides educators with customisable tools tailored to specific lesson plans. This technology also encourages collaboration and innovation, preparing students for future technological advancements."
    },
    { 
        question: "Can Printingy handle bulk orders for educational book printing?   ", 
        answer: "Yes, Printingy specialises in educational book printing, providing cost-effective solutions for bulk orders. Bulk printing ensures consistent quality across all copies and reduces per-unit costs, making it economical for schools and publishers. We use advanced printing technology to produce durable and visually engaging textbooks, workbooks, and study guides. Quick turnaround times ensure that large orders are delivered on schedule, supporting the timely distribution of educational materials. Whether for a single institution or a large publishing project, Printingy offers reliable bulk printing services."
    },
    { 
        question: "What materials are used for education printing services? ", 
        answer: "Our education printing services use durable materials such as high-quality paper, eco-friendly options, and advanced 3D printing materials. We use thick, tear-resistant paper with matte or glossy finishes for books and printed materials to ensure longevity and readability. Posters and flyers are printed on weather-resistant paper for extended use. For 3D models, we use durable plastics and biodegradable materials to create precise and sustainable learning tools. These materials are carefully selected to meet the needs of academic environments while maintaining quality and durability."
    },
    { 
        question: "Who benefits from education printing services?  ", 
        answer: "Schools, universities, training centres, and publishers benefit significantly from Printing for Education. Educational institutions use printing services for textbooks, workbooks, and classroom materials. Publishers use these services to produce large-scale academic publications. Training centres leverage printed materials and 3D models to support hands-on learning and certifications. Students benefit from high-quality resources that enhance their learning experience, while educators gain access to tools that make teaching more effective and engaging. The versatility of education printing makes it essential for academic success."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing for Education');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes


  return (
    <div>
    <MetaManager 
  title=" Professional Education Printing Services"
  description="High-quality printing for education, including educational books, 3D printing for learning tools, and custom education printing services for schools and institutions."
  keywords="Printing for Education,
3D Printing Education,
Education Printing,
Education Printing Services,
Educational Books Printing
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing for Education  </h1>
              <h2 className="text-muted">Customised printing solutions for schools, colleges, and educational institutions  </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Education printing encompasses many materials essential for academic and learning purposes. Printingy specialises in Printing for Education, delivering high-quality education printing services tailored for schools, colleges, and training institutions.</p>
          <p>Our offerings include educational book printing, creating durable and vibrant textbooks, workbooks, and study guides. For innovative learning tools, we provide 3D printing education solutions, producing custom models and prototypes for STEM and experiential learning. Our Education Printing services also cover custom classroom posters, flyers, and promotional materials to support educational events and activities.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Education Printing Solutions  </h2>
                <h3 className="large-hed">High-quality, innovative materials to enhance learning experiences  </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing for Education tailored to academic needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Comprehensive education printing services for schools, universities, and training centres.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional educational book printing with durable materials and vibrant designs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced 3D printing education solutions for custom learning tools and prototypes.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-resolution visuals for posters, flyers, and event materials.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable and eco-friendly materials suitable for extended use.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted by educational institutions, publishers, and event organisers.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/education.jpg" // Path relative to the public folder
                  alt="Professional printing for education services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Education Printing Delivered On Time </h2>
            <h3 className="small-hed">Focus on teaching while we manage your educational printing needs </h3>
            <p>At Printingy, we combine advanced technology with premium materials to deliver exceptional education printing solutions. From textbooks to innovative 3D models, our services ensure durable and visually appealing results that support educational excellence.
            </p>
            <p>With a commitment to quality and efficiency, Printingy guarantees timely delivery for all bulk and customised orders. Partner with us for reliable and impactful printing solutions tailored for education.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default Education;
